import { signout } from "@api/authentication";
import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
} from '@chakra-ui/react';
import PopupComponent from '@components/popup';
import appConfig from "@core/appconfig";
import { sanityIoImageLoader } from '@core/utils';
import { isLoggedIn, profileState } from "@recoil/atoms/profile";
import { Bookmark, ChevronRight, CircleEllipsis, ClipboardList, LogOut, MapPinHouse, Minus, Newspaper, Pencil, Plus, Settings, ShoppingBag, ShoppingCart, Wallet } from "lucide-react";
import dynamic from "next/dynamic";
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from "next/router";
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

const Header = dynamic(() => import("../header").then((mod) => mod.Header), {
    ssr: false,
});


const Navbar = dynamic(
    () => import('../navbar').then((mod) => mod.Navbar),
    {
        ssr: false,
    }
);

interface Props {
    homeLink?: string
    isShowSidebar?: boolean

}

export const Sidebar: React.FC<Props> = ({ homeLink, isShowSidebar }) => {
    const [showSidebar, setShowSidebar] = useState(isShowSidebar);
    const [userLoggedIn, setUserLoggedIn] = useRecoilState(isLoggedIn);
    const [showModal, setShowModal] = useState(false);
    const profile = useRecoilValue(profileState)
    const router = useRouter();

    const orderId = typeof window !== "undefined" && localStorage.getItem("orderId");

    const signOutCallback = () => {
        signout().then((res) => {
        }).catch((err) => {
        }).finally(() => {
            setUserLoggedIn(false);
            localStorage.removeItem('token')
            localStorage.removeItem('profile')
            document.cookie = "access_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
            setShowModal(false);
            setShowSidebar(false);
            router.push("/");
        });
    }

    useEffect(() => {
        setUserLoggedIn(localStorage.getItem('token')?.length > 0)

    }, [router.isReady])

    return (
        <div>
            {showSidebar ? (
                <div>
                    <div className={`top-0 left-0 w-72 md:w-1/2 lt-sm:w-full bg-neutral-100 overflow-auto ${showSidebar ? "transition duartion-0" : "transition duartion-0"} text-neutral-50 fixed h-full z-40 ease-in-out`}>
                        <Header />
                        <div className="flex flex-col gap-3 p-4">
                            {userLoggedIn ?
                                <>
                                    <div className="grid p-4 bg-neutral-50 rounded-md">
                                        <div className="flex justify-between ">
                                            <div className="flex gap-2 ">
                                                <Image
                                                    loader={sanityIoImageLoader}
                                                    src={profile?.profile_image || "/consumer/circular-logo.png"}
                                                    width="45"
                                                    height="45"
                                                    alt="logo"
                                                    loading="eager"
                                                    className="rounded-full"
                                                />
                                                <div className="grid gap-1 items-center text-neutral-900">
                                                    <p className="text-xl text-neutral-900 font-manrope font-semibold">{profile?.first_name}</p>
                                                    <p className="text-sm text-neutral-900 font-manrope font-medium">+91 {profile?.phone}</p>
                                                </div>
                                            </div>
                                            <div className="flex text-xl items-center text-neutral-900">
                                                <Link href={"/account/profile"} prefetch={false}>
                                                    <Pencil />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div></div>
                                </>
                                :
                                <div className="grid gap-4 grid-cols-2 p-4 bg-neutral-50 rounded-md">
                                    <Link href="/login" prefetch={false}>
                                        <button className="whitespace-nowrap border border-gray-900 text-xl text-neutral-900 w-full rounded-md bg-neutral-50 font-semibold p-1 font-semibold">Login</button>
                                    </Link>
                                    <Link href="/signup" prefetch={false}>
                                        <button className="whitespace-nowrap border border-black text-xl text-neutral-50 w-full rounded-md bg-neutral-900 font-semibold p-1 font-semibold">Sign Up</button>
                                    </Link>
                                </div>
                            }
                            {/* <Link href={homeLink || "/"}><div className="text-base font-manrope bg-neutral-50 rounded-md font-semibold text-neutral-900 p-2">Home</div></Link> */}
                            {(orderId !== null && orderId !== undefined) && <Link href={'/cart/vieworder'} prefetch={false}>
                                <div className="flex justify-between bg-neutral-50 rounded-md py-3 px-2">
                                    <div className="flex gap-2">
                                        <span className="flex items-center text-xl font-semibold text-neutral-900"><ClipboardList /></span>
                                        <span className="flex items-center text-base font-semibold text-neutral-900">Your Recent Order</span>
                                    </div>
                                    <span className="flex items-center text-xl text-neutral-900 font-semibold">
                                        <ChevronRight />
                                    </span>
                                </div>
                            </Link>}
                            <Link href={'/cart'} prefetch={false}>
                                <div className="flex justify-between bg-neutral-50 rounded-md py-3 px-2">
                                    <div className="flex gap-2">
                                        <span className="flex items-center text-xl font-semibold text-neutral-900"><ShoppingCart /></span>
                                        <span className="flex items-center text-base font-semibold text-neutral-900">My Cart</span>
                                    </div>
                                    <span className="flex items-center text-xl text-neutral-900 font-semibold">
                                        <ChevronRight />
                                    </span>
                                </div>
                            </Link>
                            <Link href={'/order/me'} prefetch={false}>
                                <div className="flex justify-between bg-neutral-50 rounded-md py-3 px-2">
                                    <div className="flex gap-2">
                                        <span className="flex items-center text-xl font-semibold text-neutral-900"><ShoppingBag /></span>
                                        <span className="flex items-center text-base font-semibold text-neutral-900">My Orders</span>
                                    </div>
                                    <span className="flex items-center text-xl text-neutral-900 font-semibold">
                                        <ChevronRight />
                                    </span>
                                </div>
                            </Link>
                            <Link href={'/service/me'} prefetch={false}>
                                <div className="flex justify-between bg-neutral-50 rounded-md py-3 px-2">
                                    <div className="flex gap-2">
                                        <span className="flex items-center text-xl font-semibold text-neutral-900"><Bookmark /></span>
                                        <span className="flex items-center text-base font-semibold text-neutral-900">My Bookings</span>
                                    </div>
                                    <span className="flex items-center text-xl text-neutral-900 font-semibold">
                                        <ChevronRight />
                                    </span>
                                </div>
                            </Link>
                            <Link href={'/account/addresses'} prefetch={false}>
                                <div className="flex justify-between bg-neutral-50 rounded-md py-3 px-2">
                                    <div className="flex gap-2">
                                        <span className="flex items-center text-xl font-semibold text-neutral-900"><MapPinHouse /></span>
                                        <span className="flex items-center text-base font-semibold text-neutral-900">My Addresses</span>
                                    </div>
                                    <span className="flex items-center text-xl text-neutral-900 font-semibold">
                                        <ChevronRight />
                                    </span>
                                </div>
                            </Link>
                            <Link href={'/business-and-brand-stories'} prefetch={false}>
                                <div className="flex justify-between bg-neutral-50 rounded-md py-3 px-2">
                                    <div className="flex gap-2">
                                        <span className="flex items-center text-xl font-semibold text-neutral-900"><Newspaper /></span>
                                        <span className="flex items-center text-base font-semibold text-neutral-900">Blogs</span>
                                    </div>
                                    <span className="flex items-center text-xl text-neutral-900 font-semibold">
                                        <ChevronRight />
                                    </span>
                                </div>
                            </Link>
                            <Link href={''} prefetch={false}>
                                <div className="flex justify-between bg-neutral-50 rounded-md py-3 px-2">
                                    <div className="flex gap-2">
                                        <span className="flex items-center text-xl font-semibold text-neutral-900"><Settings /></span>
                                        <span className="flex items-center text-base font-semibold text-neutral-900">Settings</span>
                                    </div>
                                    <span className="flex items-center text-xl text-neutral-900 font-semibold">
                                        <ChevronRight />
                                    </span>
                                </div>
                            </Link>
                            <Link href={'/refer'} prefetch={false}>
                                <div className="flex justify-between bg-neutral-50 rounded-md py-3 px-2">
                                    <div className="flex gap-2">
                                        <span className="flex items-center text-xl font-semibold text-neutral-900"><Wallet /></span>
                                        <span className="flex items-center text-base font-semibold text-neutral-900">Refer and Earn</span>
                                    </div>
                                    <span className="flex items-center text-xl text-neutral-900 font-semibold">
                                        <ChevronRight />
                                    </span>
                                </div>
                            </Link>
                            <div>
                                <Accordion allowMultiple>
                                    <AccordionItem>
                                        {({ isExpanded }) => (
                                            <>
                                                <div className={`flex bg-neutral-50 ${isExpanded ? "rounded-t-md" : "rounded-md"} py-3 px-2`}>
                                                    <AccordionButton>
                                                        <Box as="span" flex='1' textAlign='left'>
                                                            <span className="flex gap-2 items-center text-base font-semibold text-neutral-900"><CircleEllipsis />More</span>
                                                        </Box>
                                                        {isExpanded ? (
                                                            <span className="flex items-center text-md text-neutral-900 font-semibold">
                                                                <Minus />
                                                            </span>

                                                        ) : (
                                                            <span className="flex items-center text-md text-neutral-900 font-semibold">
                                                                <Plus />
                                                            </span>

                                                        )}
                                                    </AccordionButton>
                                                </div>
                                                <AccordionPanel pb={4}>
                                                    <div className={`flex py-2 px-4 bg-neutral-50 flex-col gap-2 ${isExpanded ? "rounded-b-md" : ""}`}>
                                                        <Link href={'/about'} prefetch={false}><div className="text-base font-semibold text-neutral-900">About Us</div></Link>
                                                        <Link href={'/terms'} prefetch={false}><div className="text-base font-semibold text-neutral-900">Terms of Use</div></Link>
                                                        <Link href={'/privacy'} prefetch={false}><div className="text-base font-semibold text-neutral-900">Privacy Policy</div></Link>
                                                        <Link href={'/refund'} prefetch={false}><div className="text-base font-semibold text-neutral-900">Refund Policy</div></Link>
                                                        <Link href={'/return'} prefetch={false}><div className="text-base font-semibold text-neutral-900">Return Policy</div></Link>
                                                        <Link href={'/shipping'} prefetch={false}><div className="text-base font-semibold text-neutral-900">Shipping Policy</div></Link>
                                                        {appConfig?.partnerWithUs?.length > 0 && <Link href={appConfig?.partnerWithUs} prefetch={false}><div className="text-base font-semibold text-neutral-900">Partner with us</div></Link>}
                                                        {appConfig?.sellOnPlatform?.length > 0 && <Link href={appConfig?.sellOnPlatform} prefetch={false}><div className="text-base font-semibold text-neutral-900">Sell on {appConfig?.appName}</div></Link>}
                                                    </div>
                                                </AccordionPanel>
                                            </>
                                        )}
                                    </AccordionItem>
                                </Accordion>
                            </div>

                            {userLoggedIn ?
                                <>
                                    <div className="flex gap-2 bg-neutral-50 rounded-md py-3 px-2">
                                        <span className="flex items-center text-xl font-semibold text-error-500"><LogOut /></span>
                                        <button className="flex justify-start text-error-500 text-base font-manrope font-semibold w-full" onClick={() => setShowModal(!showModal)} >Log Out</button>
                                    </div>
                                </>
                                :
                                <>
                                </>}
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )
            }
            <svg
                onClick={() => setShowSidebar(!showSidebar)}
                className="z-30 flex items-center cursor-pointer "
                fill="#FFFFFF"
                viewBox="0 0 100 80"
                width="30"
                height="30"
            >
                <rect width="100" height="10"></rect>
                <rect y="30" width="100" height="10"></rect>
                <rect y="60" width="100" height="10"></rect>
            </svg>

            {/* Confirm Popup */}
            <PopupComponent
                closeBtnName='Go Back'
                btnName='Yes Log Out'
                showModal={showModal}
                setShowModal={setShowModal}
                title={<><span className='font-semibold text-lg'>Log Out ?</span><p className="block font-semibold text-base text-neutral-500">Are you sure to log out your account?</p></>}
                ActionFun={signOutCallback}
            />
        </div >
    )
}


